export const findDataByLanguage = <T extends { fs_language: string }>(
    response: { data: { _embedded: { 'rh:doc': T[] } } },
    language: string
): T =>
    response.data._embedded['rh:doc'].find(data => data.fs_language.toLowerCase() === language.toLowerCase());

/**
 * Check if the current page is a online support application or the online support start page.
 *
 * @param pathname window.location.pathname
 * @returns true if the current page is a online support application or the online support start page
 */
export const isOnlineSupportApplication = (pathname: string) => {
    if (isUserAdministrationApplication()) {
        return false;
    }

    return pathname.startsWith('/os/') || new RegExp('/online([_\\-])support.*').test(pathname);
};

/**
 * Check if the current page is the user administration of CRM
 *
 * @returns true if the current page is current page is the user administration
 */
const isUserAdministrationApplication = () => {
    if (!window.location.search) {
        return false;
    }

    return window.location.search.toLowerCase().includes('application_admin');
};
